import { on } from 'delegated-events'
import { handleValidation, handleBlur } from '../common/validation'

const fn = {
  init: () => {
    on('blur', '.has-error', handleBlur, { capture: true })
    on('change', '.has-error', handleBlur, { capture: true })
    on('change', '.has-error blur', handleBlur, {
      capture: true,
    })
    on('submit', '[data-form-validate]:not(.multistepform)', (e) => handleValidation(e.target))
    on('submit', '[data-form-ajax]', fn.handleAjax)

    on('change', '.form-all-group input[type="checkbox"]', fn.handleAllGroup)

    fn.setupSpecialFields()
  },

  setupSpecialFields: () => {
    document.querySelectorAll('form').forEach(($form) => {
      // Setup file inputs
      $form.querySelectorAll('input[type=file]').forEach(($input) => {
        const $placeholder = document.createElement('div')
        $placeholder.classList.add('file-input-placeholder')
        $placeholder.classList.add('is-hidden')

        if ($input.value) {
          $placeholder.textContent = $input.files[0].name
          $placeholder.classList.remove('is-hidden')
        } else {
          $placeholder.classList.add('is-hidden')
        }

        $input.parentNode.insertBefore($placeholder, $input)

        $placeholder.addEventListener('click', () => $input.click())

        $input.addEventListener('change', (e) => {
          $placeholder.textContent = e.target.files[0].name
          $placeholder.classList.remove('is-hidden')
        })
      })
    })
  },

  handleAllGroup: (e) => {
    const isAll = e.target.value === 'All'
    const group = e.target.closest('.form-all-group')

    if (group) {
      const allEl = group.querySelector('input[value="All"]')

      if (allEl && isAll) {
        if (allEl.checked) {
          group.querySelectorAll('[type="checkbox"]').forEach((x) => (x.checked = true))
        } else {
          group.querySelectorAll('[type="checkbox"]').forEach((x) => (x.checked = false))
        }
      }

      if (allEl && !isAll) {
        allEl.checked = false
      }
    }
  },

  handleAjax: (e) => {
    e.preventDefault()

    const $form = e.target
    const isValid = handleValidation($form)

    if (isValid) {
      const $formMessages = $form.querySelector('.form-messages')
      const $submitButton = $form.querySelector('[type=submit]')
      let autoHideMessage = true
      fn.toggleSubmit($submitButton)

      ajax
        .url($form.action)
        .body(new FormData($form))
        .post()
        .json((res) => {
          if (res.success) {
            $form.reset()
            $form.querySelectorAll('select').forEach((x) => (x.value = null))
            $form.querySelectorAll('.file-input-placeholder').forEach((x) => x.classList.add('is-hidden'))
            $form.querySelectorAll('.toggle-fields').forEach((x) => x.classList.add('_hidden'))

            if ($form.dataset.hideOnSubmit) {
              $form.querySelectorAll('.form-content').forEach((x) => x.classList.add('_hidden'))
              autoHideMessage = false
            }
          }

          if (res.message) {
            fn.showFormMessages($formMessages, res.message, res.success, autoHideMessage)
          }
        })
        .catch(() => {
          fn.showFormMessages($formMessages, 'Sorry, there was a problem with your submission')
        })
        .finally(() => {
          fn.toggleSubmit($submitButton)
        })
    }
  },

  toggleSubmit: ($submitButton) => {
    $submitButton.disabled = !$submitButton.disabled
    $submitButton.classList.toggle('btn-loading')
  },

  showFormMessages: ($holder, message, success, autoHide) => {
    $holder.style.display = 'block'
    $holder.innerHTML = message

    if (success) {
      $holder.classList.remove('form-message-error')
    } else {
      $holder.classList.add('form-message-error')
    }

    if (autoHide) {
      setTimeout(() => {
        $holder.style.display = 'none'
      }, 5000)
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
